import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SeminarDateSeriesDetailsModel } from '../../../../../models/seminar.model';
import { AlertService } from '../../../../../services/alert.service';
import { SeminarService } from '../../../../../services/seminar.service';
import { TabMenuTabModel } from '../../../../shared-components/tab-menu/tab-menu.component';
import { FileService } from '../../../../../services/file.service';
import { FileModel } from '../../../../../models/file.model';
import { take } from 'rxjs';

enum SeminarTabEnum {
  DETAILS = 'details',
  ATTENDEES = 'attendees',
}

@Component({
  selector: 'app-admin-seminar-details',
  templateUrl: './seminar-details.component.html',
  styleUrl: './seminar-details.component.scss',
  standalone: false,
})
export class AdminSeminarDetailsComponent implements OnInit {
  public isLoading: boolean = true;
  public seminarDateSeries: SeminarDateSeriesDetailsModel;
  public activeTab: SeminarTabEnum = SeminarTabEnum.DETAILS;
  public files: FileModel[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private seminarService: SeminarService,
    private location: Location,
    private alertService: AlertService,
    private router: Router,
    private fileService: FileService
  ) {}

  public tabs = [
    {
      key: 'details',
      label: 'Seminar Daten',
      iconClass: 'fa-book-copy',
    },
    {
      key: 'attendees',
      label: 'Teilnehmer',
      iconClass: 'fa-user',
    },
  ];

  async ngOnInit(): Promise<void> {
    const dateSeriesIdParam =
      this.activatedRoute.snapshot.params['dateSeriesId'];
    if (!dateSeriesIdParam) {
      this.location.back();
    }
    await this.getSeminar(+atob(dateSeriesIdParam));
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['tab']) {
        this.activeTab = params['tab'];
      }
    });
    this.isLoading = false;
    this.loadFiles();
  }

  private async getSeminar(seminarDateSeriesId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.seminarService
        .getSeminarDateSeriesById(seminarDateSeriesId)
        .subscribe({
          next: seminarDateSeries => {
            console.log(seminarDateSeries);
            this.seminarDateSeries = seminarDateSeries;
            resolve();
          },
          error: error => {
            console.error('Error fetching seminar', error);
            this.alertService.showErrorAlert(
              'Das Seminar konnte nicht geladen werden.'
            );
            reject();
          },
        });
    });
  }

  public onTabChange(tab: TabMenuTabModel): void {
    // add query param to url
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        tab: tab.key,
      },
    });
  }

  private loadFiles(): void {
    if (!this.seminarDateSeries?.seminar?.id) return;
    this.fileService
      .getFilesBySeminar(this.seminarDateSeries.seminar.id)
      .pipe(take(1))
      .subscribe(files => {
        this.files = files.sort(
          (a, b) => (a.position ?? 0) - (b.position ?? 0)
        );
        this.files.forEach((f, i) => (f.position = i + 1));
      });
  }

  public onFilesReordered(files: FileModel[]): void {
    this.files = files;
  }
}
